export const WhenTakenMoviesLogo = (props: { gamePage?: boolean }) => {
  const textClasses = props.gamePage ? '2xl:flex' : 'md:flex';

  return (
    <div className="relative top-1 inline-flex flex-row items-center gap-1.5">
      <img src="/assets/images/whentaken-movies.svg" className="size-9" />
      <div className={`hidden text-xl ${textClasses} gap-2 2xl:text-3xl`}>
        <strong className="font-light leading-none">WhenTaken</strong>
        <span className="font-semibold leading-none"> Movies</span>
      </div>
    </div>
  );
};
